<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-spin :spinning="spinning">
          待开发...

         

        <div class="content_foote_btn">
          <a-button type="primary" class="btn" @click="contetAdd" :loading="spinning">保存更改</a-button>
          <!-- <a-button type="primary" class="btn">存入草稿</a-button> -->
        </div>
      </a-spin>
    </div>
     
  </a-card>
</template>

<script>

export default {
  name: 'PageStyle',
  components: {
     
  },
  data() {
    return {
       spinning:false
    }
  },
  created() {
     
  },
  methods: {
     contetAdd(){

     }
  },
  mounted() {
     
  },
 
}
</script>

<style lang="less">
 
 .content_foote_btn {
  padding-top: 10px;
  display: flex;
  justify-content: center;
}
.btn {
  margin: 0 10px;
}
.custom-tree {
  /deep/ .ant-menu-item-group-title {
    position: relative;
    &:hover {
      .btn {
        display: block;
      }
    }
  }

  /deep/ .ant-menu-item {
    &:hover {
      .btn {
        display: block;
      }
    }
  }

  /deep/ .btn {
    display: none;
    position: absolute;
    top: 0;
    right: 10px;
    width: 20px;
    height: 40px;
    line-height: 40px;
    z-index: 1050;

    &:hover {
      transform: scale(1.2);
      transition: 0.5s all;
    }
  }
}
</style>